import { get } from 'lodash';

import { Action } from '../actions';
import { UPDATE_CLIENT_MOBILE_APPS_DATA } from '../actions/clientMobileAppsData';
import {
    ADD_MOBILE_APP,
    APP_FLAT_SETTINGS_CHANGE,
    CLEAR_MOBILE_APPS_ERROR,
    FETCH_APP_DATA,
    FETCH_APP_INFO,
    FILL_APP_DATA,
    SET_INITIAL_CREATE_APP_PAGE_STATUS,
    SHOW_FETCH_CREATE_APP_ERROR,
    SHOW_IN_AD_CHANGE,
    UPDATE_APP_INFO,
    UPDATE_MOBILE_APP
} from '../actions/mobile-app';
import { TrackingParametersEditorActionType } from '../actions/trackingParametersEditor';
import { MobileAppPageState } from '../typings/mobile-apps';
import { MobileAppsState, State } from '../typings/state';

const AppInfoInitial = {
    name: '',
    iconUrl: '',
    rating: 0,
    votes: 0,
    price: 0
};

const AppSettingsInitial = {
    link: '',
    name: '',
    showInAd: {},
    tracker: {},
    canEditMobileAppDomain: false,
    canViewMobileAppDomain: false
};

export const AppInitialState: MobileAppsState = {
    pageState: MobileAppPageState.initial,
    appInfo: AppInfoInitial,
    appSettings: AppSettingsInitial
};

export function mobileAppsCreate(
    state: MobileAppsState = AppInitialState,
    action: Action,
    fullState: State
): MobileAppsState {
    switch (action.type) {
        case UPDATE_CLIENT_MOBILE_APPS_DATA:
            return {
                ...state,
                appSettings: {
                    ...state.appSettings,
                    canEditMobileAppDomain: get(action, 'data.canEditMobileAppDomain'),
                    canViewMobileAppDomain: get(action, 'data.canViewMobileAppDomain')
                }
            };
        case FETCH_APP_INFO:
        case FETCH_APP_DATA:
            return {
                ...state,
                pageState: MobileAppPageState.loading
            };
        case UPDATE_APP_INFO:
            return {
                ...state,
                pageState: MobileAppPageState.initial,
                appInfo: action.appInfo ? action.appInfo : AppInitialState.appInfo,
                appSettings: {
                    ...state.appSettings,
                    name: action.appInfo ? action.appInfo.name : AppInitialState.appInfo.name,
                    showInAd: action.appInfo
                        ? {
                              price: false,
                              rating: !!action.appInfo.rating,
                              votes: !!action.appInfo.votes,
                              icon: !!action.appInfo.iconUrl
                          }
                        : {},
                    domain: action.appInfo && action.appInfo.publisherDomain
                },
                errors: []
            };
        case FILL_APP_DATA:
            const appData = action.app;

            if (appData) {
                appData.appSettings.canEditMobileAppDomain = get(state, 'appSettings.canEditMobileAppDomain', false);

                appData.appSettings.canViewMobileAppDomain = get(state, 'appSettings.canViewMobileAppDomain', false);
            }

            return {
                ...state,
                pageState: MobileAppPageState.initial,
                appInfo: appData ? appData.appInfo : AppInfoInitial,
                appSettings: appData ? appData.appSettings : AppSettingsInitial,
                errors: []
            };
        case APP_FLAT_SETTINGS_CHANGE:
            return {
                ...state,
                appSettings: {
                    ...state.appSettings,
                    ...action.value
                },
                errors: state.errors ? state.errors.filter(({ path }) => !Object.keys(action.value).includes(path)) : []
            };
        case SHOW_IN_AD_CHANGE:
            return {
                ...state,
                appSettings: {
                    ...state.appSettings,
                    showInAd: { ...state.appSettings.showInAd, ...action.value }
                }
            };
        case SHOW_FETCH_CREATE_APP_ERROR:
            return {
                ...state,
                pageState: MobileAppPageState.initial,
                errors: action.errors
            };
        case SET_INITIAL_CREATE_APP_PAGE_STATUS:
            return {
                ...state,
                pageState: MobileAppPageState.initial
            };
        case CLEAR_MOBILE_APPS_ERROR:
            return {
                ...state,
                errors:
                    action.pathes.length && state.errors
                        ? state.errors.filter(({ path }) => !action.pathes.includes(path))
                        : []
            };
        case ADD_MOBILE_APP:
        case UPDATE_MOBILE_APP:
            return {
                ...state,
                pageState: MobileAppPageState.saving
            };
        case TrackingParametersEditorActionType.TRACKING_SYSTEM_CHANGE:
            return {
                ...state,
                errors: []
            };
        default:
            return state;
    }
}
